import { imgs } from "../../assets/imgs";
import { svgs } from "../../assets/svgs";
import { useResizeImg } from "../../hooks/useResizeImg";
import { Slides } from "../Slides";
import { VCLogos } from "./VCLogos";
import heroVideo from "../../assets/videos/backgroundvideo4.mp4";

export const Hero = () => {
    const heroImgs = [
        imgs.home.slide5,
        imgs.home.slide6,
        imgs.home.slide7,
        imgs.home.slide8,
        imgs.home.slide9,
    ]
    const heroSvg = useResizeImg(svgs.heroHomeDesktop, svgs.heroHomeMobile)

    return (
        <div className='hero'>
            <section>
                {heroSvg}
                <div className='date-location'>
                    <h2>September 4th & 5th, 2024</h2>
                    <h3>Javits Center, New York City</h3>
                </div>
            </section>
            <section>
                {/* <Slides imgs={heroImgs} /> */}
                <video loop autoPlay muted preload="none" poster={imgs.home.heroVideoPoster}>
                    <source src={heroVideo} type="video/mp4" />
                </video>
            </section>
            <div>
                <VCLogos />
            </div>
        </div>
    )
}